module.exports = __webpack_public_path__ + "static/media/icons_facebookwhite.bb161564.svg";